import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from "./../../services/shared.service";
import { Component, OnInit } from "@angular/core";
import { CompanyList } from "src/app/models/company-list";

@Component({
  selector: "app-select-company-modal",
  templateUrl: "./select-company-modal.component.html",
  styleUrls: ["./select-company-modal.component.scss"],
})
export class SelectCompanyModalComponent implements OnInit {
  companies: CompanyList[];
  company: CompanyList;

  constructor(
    private _service: SharedService,
    public translate: TranslateService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.companies = this._service.allMarketCompanies;
  }

  customSearchFn(term: string, item: CompanyList) {
    term = term.toLowerCase();
    return (
      item?.ENG_NAME?.toLowerCase().includes(term) ||
      item?.ARB_NAME?.toLowerCase().includes(term) ||
      item?.Reuters?.toLowerCase().includes(term)
    );
  }

  navigateDetails() {
    this.dialog.closeAll();
    this.router
      .navigate([
        "/company-profile",
        this.company.SYMBOL_CODE,
        this.company.Reuters,
      ])
      .finally(() => {
        window.scrollTo(0, document.body.scrollHeight);
      });
  }

  ngOnInit(): void {}
}
